<template>
  <div class="commodity">
    <!-- <div @click="handleDownload">1111</div> -->
    <div class="content">
      <div class="fx search">
        <el-input
          class="ipt_width"
          v-model="searchInfo.name"
          @clear="handlerClear('name')"
          clearable
          placeholder="请输入商品名称"
        ></el-input>
        <el-select
          class="select_width"
          v-model="searchInfo.typeId"
          @clear="handlerClear('typeId')"
          placeholder="请选择商品分类"
          clearable
        >
          <el-option
            v-for="item in sort"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          >
          </el-option>
        </el-select>

        <el-input
          class="ipt_width"
          v-model="searchInfo.barCode"
          @clear="handlerClear('barCode')"
          clearable
          placeholder="请输入商品条形码"
        ></el-input>
        <el-button type="primary" icon="el-icon-search" @click="handlerClick"
          >搜索</el-button
        >
        <el-button class="add_button" type="primary" @click="handlerAdd"
          >新增</el-button
        >
      </div>

      <my-eltable
        class="myTable"
        ref="mt"
        id="printTable"
        :tableData="tableData"
        :tabheight="tabheight"
        :tableHeader="tableHeader"
        :loading="loading"
        :isshow="isshow"
        :total="total"
        :operateList="operateList"
        @handlerTable="handlerModify"
        @handlerDelete="delClick"
      >
      </my-eltable>
      <!-- 分页 -->
      <div class="fy">
        <el-pagination
          class="fx fend"
          background
          :page-sizes="[10, 20, 30, 40]"
          :page-size="100"
          layout="sizes, prev, pager, next"
          :total="total"
          @current-change="currentChange"
          @size-change="handleSizeChange"
        >
        </el-pagination>
      </div>
    </div>

    <el-dialog :title="isModify ? '修改商品' : '新增商品'" :visible.sync="dialogFormVisible">
      <el-form :model="form" label-width="100px" ref="commodityInfo">
        <el-form-item label="商品名称">
          <el-input v-model="form.name"></el-input>
        </el-form-item>
        <el-form-item label="商品图片">
          <el-upload
            class="avatar-uploader"
            :action="uploadUrl"
            :headers="headers"
            :show-file-list="false"
            :on-success="handleAvatarSuccess"
            :before-upload="beforeAvatarUpload"
          >
            <img v-if="imgUrl" :src="imgUrl" class="avatar" />
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
        </el-form-item>

        <el-form-item label="商品条码">
          <el-input v-model="form.barCode"></el-input>
        </el-form-item>
        <el-form-item label="商品价格">
          <el-input v-model="form.shopPrice"></el-input>
        </el-form-item>
        <el-form-item label="商品分类">
          <el-select v-model="form.typeId" placeholder="请选择商品分类">
            <el-option
              v-for="item in sort"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="商品单位">
          <el-select v-model="form.unitId" placeholder="请选择商品单位">
            <el-option
              v-for="item in unit"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="上架/下架" >
          <el-switch v-model="status"> </el-switch>
         </el-form-item>
        <el-form-item label="限制库存">
          <!-- <el-input v-model="form.isInventory" placeholder="限制库存请输入0，不限库存请输入1"></el-input> -->
          <!-- <el-radio v-model="radio" @change='handlerRadio()'>{{stock[radio]}}</el-radio> -->
          <el-checkbox v-model="radio" @change="handlerCheckbox">{{
            stock[num]
          }}</el-checkbox>
        </el-form-item>
        <el-form-item v-if="this.num == 0" label="商品库存">
          <el-input v-model="form.inventory"></el-input>
        </el-form-item>

        <el-form-item v-if="isMain" label="售货店">
          <el-checkbox-group v-model="checkedShops">
            <el-checkbox
              v-for="(item, index) in shops"
              :value="item.name"
              :label="item.id"
              :key="index"
              >{{ item.name }}</el-checkbox
            >
          </el-checkbox-group>
        </el-form-item>
        <el-form-item>
          <el-button
            v-if="isModify"
            type="primary"
            @click="handlerUpdate('commodityInfo')"
            >确认修改</el-button
          >
          <el-button v-else type="primary" @click="submitForm('commodityInfo')"
            >立即新增</el-button
          >
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import {
  commodityList,
  save,
  sort,
  unit,
  selectUser,
  handlerDelete,
  getCommodityInfo,
  update,
} from "@/http/commodity.js";
import { listPage } from "@/http/api.js";
import { productcar } from "@/http/order.js";
import { UPLOAD_API, FILE_URL } from "@/config";

import MyEltable from "../../components/el_table";

export default {
  components: { MyEltable },
  data() {
    return {
      uploadUrl: UPLOAD_API, // 上传地址
      loading: false,
      isshow: true,
      tabheight: "100%",
      tableHeader: [
        // 表头
        // { prop: "id", label: "序号" },
        { prop: "barCode", label: "商品条形码" },
        { prop: "name", label: "名称" },
        { prop: "imgUrl", label: "商品图片" },
        { prop: "shopPrice", label: "商品价格" },
        { prop: "typeName", label: "商品类型" },
        { prop: "unitName", label: "商品单位" },
        { prop: "isInventoryTitle", label: "是否限制库存" },
        { prop: "inventoryTitle", label: "商品库存" },
        { prop: "statusTitle", label: "商品状态" },
      ],
      tableData: [],
      operateList: [
        { name: "修改", type: "primary", size: "mini", mark: 1 },
        { name: "删除", type: "danger", size: "mini", mark: 2 },
        // {name:'库存',type:'info',size:'mini',mark:3},
      ],
      currentPage: 1,
      pagesize: 10,
      total: 0,
      dialogFormVisible: false,
      form: {},
      imgUrl: "",
      checkedShops: [],
      shops: [],
      headers: {},
      sort: [],
      unit: [],
      isMain: false,
      radio: false,
      stock: ["限制", "不限制"],
      isModify: false,
      searchInfo: {},
      status:false,
      statusTitle:["上架","下架"]
    };
  },
  created() {
    this.commodityList();
    this.handlerUnit();
    this.handlerSort();
    this.handlerSelectUser();
  },
  computed: {
    num() {
      //0：限制库存  1：不限库存
      return this.radio ? 0 : 1;
    },
  },
  methods: {
        async getproductcar() {
      let res = await productcar({
        limit: null,
      });
      this.shops = res.data;
      console.log(this.shops);
    },
    handleDownload() {
      // this.downloadLoading = true
      import("@/vendor/Export2Excel").then((excel) => {
        console.log(excel);
        const tHeader = ["name", "imgUrl", "barCode", "shopPrice", "state"];
        const filterVal = ["name", "imgUrl", "barCode", "shopPrice", "state"];
        const list = this.tableData;
        const data = this.formatJson(filterVal, list);
        excel.export_json_to_excel({
          header: tHeader,
          data,
          filename: this.filename,
          autoWidth: this.autoWidth,
          bookType: this.bookType,
        });
        // this.downloadLoading = false
      });
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map((v) => filterVal.map((j) => v[j]));
    },
    handlerClear(val) {
      delete this.searchInfo[val];
      console.log(this.searchInfo);
    },
    handlerCheckbox(e) {
      // console.log(e);
      // this.num = e ? 0 : 1;
    },
    async handlerSelectUser() {
      let res = await selectUser();
      this.isMain = res.data.isMain == 1 ? true : false;
    },
    async handlerSort() {
      let res = await sort();
      this.sort = res.data;
    },
    async handlerUnit() {
      let res = await unit();
      this.unit = res.list;
    },
    // 更新商品update
    async handlerUpdate() {
      this.isMain && (this.form.kiosk = this.checkedShops.toString());
      console.log(this.form);
      this.form.isInventory = this.num == 1 ? 1 : 0;
      this.form.status = this.status == true ? 0 : 1; 

      let res = await update(this.form);
      console.log("res", res);
      if (res.code === 1) {
        this.$message({
          showClose: true,
          message: "修改成功",
          type: "success",
        });
        this.isModify = false;
        this.dialogFormVisible = false;
        this.commodityList();
      } else {
        this.$message({
          showClose: true,
          message: res.msg,
          type: "error",
        });
      }
    },
    // 新增商品
    async submitForm() {
      // console.log(this.checkedShops.toString());
      // return
      this.isMain && (this.form.kiosk = this.checkedShops.toString());
      console.log(this.form);
      this.form.isInventory = this.num == 1 ? 1 : 0;
      this.form.status = this.status == true ? 0 : 1; 

      let res = await save(this.form);
      if (res.code === 500) {
        this.$message({
          showClose: true,
          message: res.msg,
          type: "error",
        });
      }
      if (res.code === 1) {
        this.$message({
          showClose: true,
          message: "新增成功",
          type: "success",
        });
        this.dialogFormVisible = false;
        this.commodityList();
      }
    },
    handlerClick() {
      this.commodityList(1);
    },
    async commodityList(val) {
      if (val && val == 1) {
        this.currentPage = 1;
      }
      let query = {
        page: this.currentPage + "",
        limit: this.pagesize + "",
        ...this.searchInfo,
      };
      let res = await commodityList(query);
      this.tableData = res.data.list;
      this.tableData.forEach((item) => {
        if (item.imgUrl.indexOf("http") < 0) {
          item.imgUrl = `${FILE_URL}/${item.imgUrl}`;
        }
        item.statusTitle = this.statusTitle[item.status]
        item.isInventoryTitle = this.stock[item.isInventory]
        if(item.isInventory == 1 ) {
          item.inventoryTitle = '9999+'
        } else {
          item.inventoryTitle = item.inventory;
        }
      });
      this.total = res.data.totalCount;
    },
    //页码改变
    currentChange(val) {
      this.currentPage = val;
      this.commodityList();
    },
    //handleSizeChange
    handleSizeChange(val) {
      this.pagesize = val;
      this.commodityList();
    },
    handlerAdd() {
      this.isModify = false;
      this.form = {};
      this.imgUrl = "";
      this.radio = false;
      this.shops = [];
      this.dialogFormVisible = true;
      let token = localStorage.getItem("token");
      this.headers = {
        token,
      };
          this.getproductcar()
;
    },
    async handlerModify(val) {
      this.isModify = true;
      let token = localStorage.getItem("token");
      this.headers = {
        token,
      };

      let res = await getCommodityInfo(val.id);
      this.form = res.commodity;
      this.status = val.status == 0 ? true : false;
      this.imgUrl = val.imgUrl;
      this.checkedShops = [res.commodity.kioskId];
      this.radio = res.commodity.isInventory == 0 ? true : false;
      console.log(this.checkedShops);
          this.getproductcar()
;

      this.dialogFormVisible = true;
    },
    async delClick(val) {
      console.log("val", val);
      let res = await handlerDelete({ id: val.id });
      if (res.code === 1) {
        this.$message({
          showClose: true,
          message: "删除成功",
          type: "success",
        });
        this.commodityList();
      } else {
        this.$message({
          showClose: true,
          message: res.msg,
          type: "error",
        });
      }
    },
    handleAvatarSuccess(res, file) {
      console.log(res, file);
      this.imgUrl = URL.createObjectURL(file.raw);
      this.form.imgUrl = res.msg[0];
    },
    beforeAvatarUpload(file) {
      // const isJPG = file.type === 'image/jpeg';
      // const isLt2M = file.size / 1024 / 1024 < 2;
      // if (!isJPG) {
      //   this.$message.error('上传头像图片只能是 JPG 格式!');
      // }
      // if (!isLt2M) {
      //   this.$message.error('上传头像图片大小不能超过 2MB!');
      // }
      // return isJPG && isLt2M;
    },
    // 获取所有售货亭列表
    // async listPage() {
    //   let query = {
    //     limit: null,
    //   };
    //   let res = await listPage(query);
    //   console.log("res", res);
    //   this.shops = res.data.list;
    //   // this.total = res.data.totalCount;
    // },
  },
};
</script>

<style lang="scss" >
.commodity {
  height: 100%;
  width: 100%;
  background: #f0f2f5;
  .content {
    width: 98%;
    // height: 900px;
    height: calc(100% - 37px);
    background: #ffffff;
    margin: 16px auto 0;
    padding: 10px;
  }
  .add_button {
    color: #fff;
    background: #18b3a3;
    border: #18b3a3;
  }
}

.fy {
  width: 96%;
  margin: 10px auto 0;
}
.fend {
  justify-content: flex-end;
}

.el-pagination.is-background .el-pager li:not(.disabled).active {
  background-color: #18b3a3;
  color: #fff;
}
.el-pagination.is-background .el-pager li.active {
  color: #fff;
  cursor: default;
}
.el-pagination.is-background .el-pager li:hover {
  color: #18b3a3;
}
.el-pagination.is-background .el-pager li:not(.disabled):hover {
  color: #18b3a3;
}
.el-pagination.is-background .el-pager li:not(.disabled).active:hover {
  background-color: #18b3a3;
  color: #fff;
}

.add_button:hover {
  background: #18b3a3;
}

.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}
.avatar {
  width: 178px;
  height: 178px;
  display: block;
}

.ipt_width {
  width: 240px;
  margin-right: 20px;
}
.select_width {
  width: 150px;
  margin-right: 20px;
}
.search {
  // margin-top: 10px;
  margin-bottom: 10px;
}
</style>